// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const forestersLodge = defineModel({
  id: "foresters-lodge",
  batchId: "future",
  name: "Forester's lodge",
  tags: ["building","foresters","lodge","low-poly","age-of-mcp","future"],
  summary: "A forester's lodge — manages and replants woodland for sustainable timber.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.5,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(0.92, 0.14, 0.92), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(0.92, 0.14, 0.92), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.78, 0.34, 0.78), color: "#7a512c", position: [0, 0.31, 0] },
      { geometry: new THREE.BoxGeometry(0.8, 0.04, 0.8), color: "#5c3c20", position: [0, 0.2522, 0] },
      { geometry: new THREE.BoxGeometry(0.8, 0.04, 0.8), color: "#5c3c20", position: [0, 0.3644, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.7, 4), color: "#6b4a26", position: [-0.425, 0.35, -0.425] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.7, 4), color: "#6b4a26", position: [0.425, 0.35, -0.425] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.7, 4), color: "#6b4a26", position: [-0.425, 0.35, 0.425] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.7, 4), color: "#6b4a26", position: [0.425, 0.35, 0.425] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(0.92, 0.14, 0.92), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.78, 0.6, 0.78), color: "#7a512c", position: [0, 0.44, 0] },
      { geometry: new THREE.BoxGeometry(0.8, 0.04, 0.8), color: "#5c3c20", position: [0, 0.338, 0] },
      { geometry: new THREE.BoxGeometry(0.8, 0.04, 0.8), color: "#5c3c20", position: [0, 0.536, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [-0.425, 0.5, -0.425] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [0.425, 0.5, -0.425] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [-0.425, 0.5, 0.425] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [0.425, 0.5, 0.425] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(0.92, 0.14, 0.92), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.78, 0.6, 0.78), color: "#7a512c", position: [0, 0.44, 0] },
      { geometry: new THREE.BoxGeometry(0.8, 0.04, 0.8), color: "#5c3c20", position: [0, 0.338, 0] },
      { geometry: new THREE.BoxGeometry(0.8, 0.04, 0.8), color: "#5c3c20", position: [0, 0.536, 0] },
      { geometry: new THREE.BoxGeometry(0.92, 0.07, 0.564004), color: "#5a7a44", position: [0, 0.91, 0.225], rotation: [0.647047, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.92, 0.07, 0.564004), color: "#5a7a44", position: [0, 0.91, -0.225], rotation: [-0.647047, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.94, 0.06, 0.06), color: "#476234", position: [0, 1.08, 0] },
      { geometry: new THREE.BoxGeometry(0.22, 0.42, 0.04), color: "#4a3320", position: [0, 0.35, 0.4] },
      { geometry: new THREE.BoxGeometry(0.14, 1.1, 0.14), color: "#7d776b", position: [0.33, 0.69, -0.18] },
      { geometry: new THREE.BoxGeometry(0.6, 0.04, 0.14), color: "#5c3c20", position: [0, 0.3, 0.65] },
      { geometry: new THREE.CylinderGeometry(0.04, 0.05, 0.08, 6), color: "#8a5a3a", position: [-0.2, 0.36, 0.65] },
      { geometry: new THREE.ConeGeometry(0.06, 0.16, 6), color: "#4f8a3e", position: [-0.2, 0.48, 0.65] },
      { geometry: new THREE.CylinderGeometry(0.04, 0.05, 0.08, 6), color: "#8a5a3a", position: [0, 0.36, 0.65] },
      { geometry: new THREE.ConeGeometry(0.06, 0.16, 6), color: "#4f8a3e", position: [0, 0.48, 0.65] },
      { geometry: new THREE.CylinderGeometry(0.04, 0.05, 0.08, 6), color: "#8a5a3a", position: [0.2, 0.36, 0.65] },
      { geometry: new THREE.ConeGeometry(0.06, 0.16, 6), color: "#4f8a3e", position: [0.2, 0.48, 0.65] },
    ] },
  ],
  animations: [],
});
